var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-container',[_c('div',{staticClass:"text-right"},[_c('PeopleSort',{on:{"update":function($event){return _vm.fetchData()}}})],1),_c('PeoplePanel',{attrs:{"value":_vm.items}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }